import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookActivity } from "@modules/bookActivities/types";
import { BookActivityFormValues } from "@modules/bookActivities/validations";

import { createBookActivityService } from "./service";
import { UseCreateCategoryMutationOptions } from "./types";

export function useCreateBookActivityMutation(
  options?: UseCreateCategoryMutationOptions
) {
  const { open } = useNotification();

  return useMutation<BookActivity, ApiError, BookActivityFormValues>({
    mutationFn: createBookActivityService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
